(function(){
    'use strict';

    angular
    .module('appback')
    .controller('StockController', StockController)
 
    StockController.$inject = ["$scope","StockService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce", "$window"];
              
    function StockController($scope,StockService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce, $window)
    {     
        var vm = this;
        vm.material_id_seleccionado = '';
        vm.stocks_material = [];
        vm.cantidad_total = 0;
        vm.unidades_bloqueadas = 0;
        vm.searchLote = '';
        vm.generalLab = GenerallabService;

        vm.pagefiltros = 1;
        vm.maxPag = 0;
        vm.limitfiltros = 50;
        vm.totalResultados = 0;
        vm.paginationNumbers = [];
        vm.pagesToShow = 10;

        vm.getStocksMaterial = function() {
            console.log("Obteniendo stock para material: ", vm.material_id_seleccionado);
            StockService.getStockFromMaterial(vm.material_id_seleccionado, function(data){
                console.log("stocks materiales", data);
                if(data.code == 1){
                    vm.stocks_material = data.stocks_material;
                    vm.cantidad_total = data.cantidad_total;
                    vm.unidades_bloqueadas = data.unidades_bloqueadas;
                }
            });
        }

        vm.buscarLote = function(){
            console.log("BUSCANDO LOTE: ", vm.searchLote);
            if(vm.searchLote == ''){
                console.log("Buscando todos los lotes");
                vm.getStocksMaterial();
            }else{
                StockService.getAllStocksByLote(vm.material_id_seleccionado, vm.searchLote, function(data){
                    console.log("stocks materiales por lote", data);
                    if(data.code == 1){
                        vm.stocks_material = data.stocks_material;
                    }
                });
            }
        }

        vm.checkClearLote = function(){
            if(vm.searchLote == ''){
                vm.getStocksMaterial();
            }
        }

        vm.nuevoLoteModal = false;
        vm.nuevoLoteMaterial = function(){
            console.log("nuevo lote del material");
            vm.nuevoLoteModal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    //windowClass: 'modal-danger',
                    //backdrop  : 'static',
                    templateUrl: 'nuevolote.html',
                    size: 'lg',
                    controller: function($scope) {
                        $scope.nuevoLote = {};
                        $scope.nuevoLote.material_id = vm.material_id_seleccionado;
                        $scope.generalLab = vm.generalLab;
                        $scope.okForm = function(){
                            console.log("nuevo lote", $scope.nuevoLote);
                            StockService.setNuevoLote($scope.nuevoLote, function(data){
                                if(data.code == 1){
                                    vm.showInfoPopup("Lote creado correctamente");
                                } else{
                                    vm.showInfoPopup("Error al crear el lote");
                                }
                            });
                            vm.nuevoLoteModal.close();
                        }
                        $scope.koForm = function(){
                            vm.nuevoLoteModal.close();
                        }
                    }
                });
        }

        vm.modificarLoteModal = false;
        vm.modificarLote = function(stock){
            console.log("modificar lote", stock);
            vm.modificarLoteModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal.title-top',
                ariaDescribedBy: 'modal.body-top',
                templateUrl: 'modificarlote.html',
                size: 'lg',
                controller: function($scope){
                    $scope.stockToModify = stock;
                    $scope.generalLab = vm.generalLab;
                    $scope.operacion = "sumar";
                    $scope.cantidadGestion = "";

                    $scope.okForm = function(){
                        console.log("operacion", $scope.operacion);
                        console.log("cantidad gestion", $scope.cantidadGestion);
                        console.log("stockToModify", $scope.stockToModify);
                        StockService.setModificacionStock($scope.operacion, $scope.cantidadGestion, $scope.stockToModify, function(data){
                            console.log("return set modificacionStock", data);
                            if(data.code ==1){
                                vm.showInfoPopup("Lote modificado correctamente");
                            }else{
                                vm.showInfoPopup("Error al modificar el Lote");
                            }
                        });
                        vm.modificarLoteModal.close();
                    }
                    $scope.koForm = function(){
                        vm.modificarLoteModal.close();
                    }
                }
            });
        }

        vm.infoPopup = false;
        vm.showInfoPopup = function(title){
            console.log("show info popup", title);
            vm.infoPopup = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal.title-top',
                ariaDescribedBy: 'modal.body-top',
                templateUrl: 'infopopup.html',
                size: 'lg',
                controller: function($scope){
                    $scope.title = title;
                    $scope.koForm = function(){
                        vm.infoPopup.close();
                        vm.getStocksMaterial();
                    }
                }
            });

        }

        vm.liberarStock = function(id_stock){
            console.log('Funcion liberarStock', id_stock);
            StockService.liberarStockMaterial(id_stock, vm.cantidad_liberar, function(data){
                console.log("data liberarstock",data);
            })
        }

        vm.subirSage = function(stock_id){
            console.log('Funcion subirSage', stock_id);
            StockService.subirSage(stock_id, function(data){
                console.log("data subir sage",data);
                $window.location.reload()
            });
        }
    }
})();
